<!-- quotation-reject-popup -->
<div class="common-popup-container reject-popup-wrapper">
    <h3 class="title">{{ 'QUOTATIONNEW_SUMMARY.LBL_REJECT_QUOTATION' | translate }}</h3>
    <p class="reject-text mt-2">{{ 'QUOTATIONNEW_SUMMARY.MSG_REJECT_CONFIRMATION' | translate }}
        <span> #{{data.quotationId}} ?</span>
    </p>
    <div class="my-input-group mt-4">
        <label for="">{{ 'QUOTATIONNEW_SUMMARY.LBL_REASON' | translate }}
            <span class="asterisk"> *</span>
        </label>
        <textarea [(ngModel)]="reason" name="" id=""
            [placeholder]="'QUOTATIONNEW_SUMMARY.PH_ENTER_REJECTION_REASON' | translate"
            style="resize: none;"></textarea>
    </div>
    <div class="d-flex justify-content-end cta-container mt-4">
        <button class="tertiary-cta mr-1" (click)="cancelClicked()">{{ 'QUOTATIONNEW_SUMMARY.LBL_CANCEL' | translate
            }}</button>
        <div class="result-status-wrapper status-cta-container fail-container" (click)="saveRejectedQuotation()">
            <p class="result-status fail approval-cta ml-0">
                <img src="assets/images/thick-fail-icon.svg" class="mr-2" alt=""> {{ 'QUOTATIONNEW_SUMMARY.LBL_REJECT' |
                translate }}
            </p>
        </div>
    </div>
</div>

<div class="loader-overlay" *ngIf="isLoading">
    <div class="loader-container">
        <img src="assets/images/reload.svg" alt="">
        <span>{{'COMMON.LBL_LOADER' | translate}}</span>
    </div>
</div>